if (!customElements.get('cart-counter')) {
  class CartCounter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.span = this.querySelector('span');
      window.eventBus.on('update:cart:drawer', async (data) => {
        const { item_count } = await (await fetch('/cart.js')).json();
        this.span.textContent = item_count;
        if (item_count > 0) {
          this.span.classList.remove('hide');
        } else {
          this.span.classList.add('hide');
        }
      });
    }
  }
  customElements.define('cart-counter', CartCounter);
}